import {
  trainingManager,
  modes,
  requestManager
} from '@powerplay/core-minigames'
import { Tasks } from '../../types'
import { trainingState } from '@/stores'

/**
 * Trieda pre treningove ulohy
 */
export class TrainingTasks {

  /** Mnozstvo taskov */
  private NUMBER_OF_TASKS = 4

  /** ci uz sme ulozili timing quality */
  public timingQualitySaved = false

  /** Najlepsie hodnoty taskov */
  private bestRunUpQ = 0
  private bestDrawQ = 0
  private bestAngleQ = 0
  private bestTimingQ = 0

  /**
   * Inicializovanie treningu
   */
  public initTraining(): void {

    trainingManager.setNumberOfTasks(this.NUMBER_OF_TASKS)

  }

  /**
   * Hlavna privatna metoda, ktora riesi UI zmeny a trainingManager classu
   * @param name - meno tasku
   * @param value - Vyhodnotena hodnota tasku
   */
  public saveTaskValue(name: Tasks, value: number): void {

    if (!modes.isTrainingMode()) return

    value = Math.ceil(value) / 100

    if (name === Tasks.runUp) this.saveRunUp(value)
    if (name === Tasks.draw) this.saveDraw(value)
    if (name === Tasks.angle) this.saveAngle(value)
    if (name === Tasks.timing) this.saveTiming(value)

  }

  /**
   * Ulozenie tasku
   * @param value - Vyhodnotena hodnota
   */
  private saveRunUp(value: number): void {

    if (this.bestRunUpQ < value) {

      trainingManager.setTaskValue(Tasks.runUp, value)
      this.bestRunUpQ = value

    }

    this.changeUI(Tasks.runUp, this.bestRunUpQ)

  }

  /**
   * Ulozenie tasku
   * @param value - Vyhodnotena hodnota
   */
  private saveDraw(value: number): void {

    if (this.bestDrawQ < value) {

      trainingManager.setTaskValue(Tasks.draw, value)
      this.bestDrawQ = value

    }

    this.changeUI(Tasks.draw, this.bestDrawQ)

  }

  /**
   * Ulozenie tasku
   * @param value - Vyhodnotena hodnota
   */
  private saveAngle(value: number): void {

    if (this.bestAngleQ < value) {

      trainingManager.setTaskValue(Tasks.angle, value)
      this.bestAngleQ = value

    }

    this.changeUI(Tasks.angle, this.bestAngleQ)

  }

  /**
   * Ulozenie tasku
   * @param value - Vyhodnotena hodnota
   */
  private saveTiming(value: number): void {

    if (this.timingQualitySaved) return

    this.timingQualitySaved = true
    if (this.bestTimingQ < value) {

      trainingManager.setTaskValue(Tasks.timing, value)
      this.bestTimingQ = value

    }

    this.changeUI(Tasks.timing, this.bestTimingQ)

  }

  /**
   * Zmena UI
   * @param name - meno tasku
   * @param value - Vyhodnotena hodnota tasku
   */
  private changeUI(name: Tasks, value: number) {

    if (!modes.isTrainingMode()) return
    console.log(`UI zmeny ${name} ma hodnotu ${value}`)
    const percent = Math.ceil(value * 100)
    const tpTask = Math.ceil(Math.round((trainingManager.getTpPerTask() * value * 10) + Number.EPSILON) / 10)
    console.log('tp task:', tpTask)

    if (tpTask !== undefined) {

      trainingState().editTask({
        text: `trainingTask${requestManager.disciplineID}-${name}`,
        percent: String(percent),
        points: String(tpTask),
        showPoints: true
      })

    }

  }

  /**
   * Reset
   */
  public reset(): void {

    console.log('RESET TRAINING')
    // TODO ZMENIT NA TRAINING TASK
    this.timingQualitySaved = false
    trainingManager.resetAll()
    this.bestRunUpQ = 0
    this.bestDrawQ = 0
    this.bestAngleQ = 0
    this.bestTimingQ = 0

  }

}

export const trainingTasks = new TrainingTasks()
